import { useRef, useState } from 'react'
import { useIsHydrating } from '@muse-web/router'

import { useCurrentUser } from '@features/session'

import { useLikedAudioIds } from './useLikedAudioIds'

let likedAudioIdsAtLoad: ReadonlySet<string> | null = null

export const useAudioLikesCount = (audioId: string, serverCount: number): number => {
    const { id: myId } = useCurrentUser()
    const likedAudioIds = useLikedAudioIds(myId !== 0)
    const isHydrating = useIsHydrating()
    const [isFromInitialLoad] = useState(isHydrating)
    const isLiked = likedAudioIds.data?.includes(audioId) ?? false

    if (likedAudioIdsAtLoad === null && likedAudioIds.data !== undefined) {
        likedAudioIdsAtLoad = new Set(likedAudioIds.data)
    }

    const initiallyLiked = useRef<boolean | null>(null)
    if (initiallyLiked.current === null && likedAudioIds.data !== undefined) {
        initiallyLiked.current =
            isFromInitialLoad && likedAudioIdsAtLoad ? likedAudioIdsAtLoad.has(audioId) : isLiked
    }

    const delta =
        initiallyLiked.current === null ? 0 : Number(isLiked) - Number(initiallyLiked.current)

    return Math.max(0, serverCount + delta)
}
